import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { PitchHero } from '../components/pitch/PitchHero';
import { PlayOverlay } from '../components/pitch/PlayOverlay';
import { SignalsOverlay } from '../components/pitch/SignalsOverlay';
import { JourneySlide } from '../components/deck/slides/JourneySlide';
import { ChannelsSlide } from '../components/deck/slides/ChannelsSlide';
import { UseCasesSlide } from '../components/deck/slides/UseCasesSlide';
import { SignalsSlide } from '../components/deck/slides/SignalsSlide';
import { CompoundSlide } from '../components/deck/slides/CompoundSlide';
import { StationSlide } from '../components/deck/slides/StationSlide';
import { CampaignSlide } from '../components/deck/slides/CampaignSlide';
import { DeckNav } from '../components/deck/DeckNav';
import { StrategyOverlay } from '../components/StrategyOverlay';
import { JourneyOverlay } from '../components/JourneyOverlay';
import { StoryboardOverlay } from '../components/storyboard/StoryboardOverlay';
import { useActiveSection } from '../hooks/useActiveSection';
import { deckPages } from '../data/deck';
import type { Format } from '../types/presentation';
type Layer = 'strategy' | 'journey' | 'storyboard' | 'signals' | null;

/** Snakker × Abbott — from creative idea to commercial impact. */
export function Presentation() {
  const active = useActiveSection(deckPages.map(page => page.id));
  const [format, setFormat] = useState<Format>('mobile');
  const [playing, setPlaying] = useState(false);
  const [layer, setLayer] = useState<Layer>(null);
  const openStrategy = () => setLayer('strategy');
  const openJourney = () => setLayer('journey');
  const openStoryboard = () => setLayer('storyboard');
  const openSignals = () => setLayer('signals');
  const closeLayer = () => setLayer(null);
  return <div className="w-full bg-canvas font-sans" data-id="element-934" data-mp="3lwpv19nltf6s">
      <div className="app-shell" data-id="element-935" data-mp="3ly0y17986iwu">
        <PitchHero format={format} onFormatChange={setFormat} onPlay={() => setPlaying(true)} onStoryboard={openStoryboard} onConcept={openStrategy} onSignals={openSignals} onJourney={openJourney} data-id="element-936" data-mp="3qu98i7ch9nxo" />
        <JourneySlide data-id="element-937" data-mp="3ss9ai2r392nu" />
        <ChannelsSlide data-id="element-938" data-mp="3ssj0vrg1pbu2" />
        <UseCasesSlide data-id="element-939" data-mp="3st26q9sf89rq" />
        <SignalsSlide onOpenSignals={openSignals} data-id="element-940" data-mp="3sq68ekcnvj2r" />
        <CompoundSlide data-id="element-941" data-mp="3nswlpcgnplim" />
        <StationSlide data-id="element-942" data-mp="3nrl86kxeszeb" />
        <CampaignSlide data-id="element-943" data-mp="3nv93npmezvvo" />
        <DeckNav active={active} data-id="element-944" data-mp="5nb8nxuo16ug" />
      </div>

      <AnimatePresence data-id="element-945" data-mp="5m0621cyi54x">
        {playing && <PlayOverlay key="play" format={format} onClose={() => setPlaying(false)} onOpenStrategy={openStrategy} onOpenJourney={openJourney} onOpenStoryboard={openStoryboard} data-id="element-946" data-mp="1m7tzeoctgut" />}
      </AnimatePresence>
      <AnimatePresence data-id="element-947" data-mp="pbk0u7w7lcty">
        {layer === 'strategy' && <StrategyOverlay key="strategy" onClose={closeLayer} data-id="element-948" data-mp="pcbyrpda3mne" />}
        {layer === 'journey' && <JourneyOverlay key="journey" onClose={closeLayer} data-id="element-949" data-mp="kdijbrefllkl" />}
        {layer === 'storyboard' && <StoryboardOverlay key="storyboard" onClose={closeLayer} data-id="element-950" data-mp="13xzhr77qwl4o" />}
        {layer === 'signals' && <SignalsOverlay key="signals" format={format} onFormatChange={setFormat} onClose={closeLayer} data-id="element-951" data-mp="180473tr5uvli" />}
      </AnimatePresence>
    </div>;
}